import styled from 'styled-components';
import { Flex } from '../../layout/Flex';
import { MenuItemProps } from './types';

export const MenuItemRoot = styled(Flex).withConfig({ displayName: 'MenuItemRoot' })<MenuItemProps>`
    width: 100%;
    cursor: pointer;
    outline: none;
    -webkit-user-select: none;
    user-select: none;
    background: none;
    border: none;
    -webkit-tap-highlight-color: transparent;
    transition:
        transform 0.1s ease-out,
        background-color 0.1s ease-out;
    text-decoration: none;

    &.active,
    &:active {
        transform: scale(0.96);
    }

    &:hover {
        background-color: var(--background-secondary);
    }
`;

export const Dropdown = styled(Flex)
    .withConfig({ displayName: 'Dropdown' })
    .attrs({
        direction: 'column',
        overflow: 'hidden',
        alignItems: 'flex-start',
        justifyContent: { xs: 'space-around', sm: 'flex-start' },
        borderRadius: 1.5,
        border: '1px solid var(--divider)',
        background: 'var(--background-primary)',
    })`
    box-shadow:
        0 10px 20px -5px rgba(0, 0, 0, 0.3),
        0 0 0 1px rgba(0, 0, 0, 0.05);
`;
